<template>
  <div class="mb-5">

    <div class="modal fade" tabindex="-1" :id="'modal-' + categorySlug">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Warning!</h5>
					</div>
					<div class="modal-body"> Are you sure you want to delete the category? </div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal"> Close </button>
						<button class="btn btn-danger" @click.prevent="confirmRemoveCategory()"> Yes </button>
					</div>
				</div>
			</div>
		</div>

    <div class="modal fade" tabindex="-1" :id="'modal-remove-subcategory-' + categorySlug">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Warning!</h5>
					</div>
					<div class="modal-body"> Are you sure you want to delete the sub category? </div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal"> Close </button>
						<button class="btn btn-danger" @click.prevent="confirmRemoveSubcategory()"> Yes </button>
					</div>
				</div>
			</div>
		</div>

    <div class="modal fade" :id="'modal-add-subcategory-' + categorySlug" tabindex="-1" role="dialog">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Add Subcategory</h5>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label>Sub Category Name</label>
							<input type="text" class="form-control" autocomplete="nope" v-model="nameSubCategory">
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
						<button class="btn btn-success" @click.prevent="confirmAddSubcategory()">Add</button>
					</div>
				</div>
			</div>
		</div>

    <!-- Table - Categories -->
    <div class="c-main__table">
      <div class="c-main__table-tr row">
        <div class="c-main__table-td col"> {{ categoryName }} </div>
        <div class="c-main__table-td col-md-1 d-flex justify-content-end">
          <button type="button" class="btn btn-danger" data-toggle="modal" :data-target="'#modal-' + categorySlug">
            <font-awesome-icon :icon="['fal', 'trash']"></font-awesome-icon>
          </button>
        </div>
      </div>

      <!-- Table - Sub Categories -->
      <div class="row d-flex justify-content-end">
        <div class="col-md-11 p-0">

          <div class="c-main__table" v-for="subcategory in subcategories" :key="subcategory['.key']">
            <div class="c-main__table-tr row">
              <div class="c-main__table-td col"> {{ subcategory.name }} </div>
              <div class="c-main__table-td col-md-1 d-flex justify-content-end">
                <button type="button" class="btn btn-danger" data-toggle="modal" :data-target="'#modal-remove-subcategory-' + categorySlug" @click.prevent="keySubcategory = subcategory['.key']">
                  <font-awesome-icon :icon="['fal', 'trash']"></font-awesome-icon>
                </button>
              </div>
            </div>
          </div>

          <button type="button" class="btn btn-block btn-add-subcategory" data-toggle="modal" :data-target="'#modal-add-subcategory-' + categorySlug">
            <font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon>
            <span>Add Sub Category</span>
          </button>

        </div>
      </div>

		</div>

  </div>
</template>

<script>
	import { categories, storageFiles } from '../../firebase'
  import { busNotifications } from '../../bus'

  export default {
    props: [ 'categoryName', 'categorySlug', 'categoryKey', 'categoryBackground' ],
    data() {
      return {
        nameSubCategory: '',
        keySubcategory: '',
      }
    },
    firestore() {
      return {
        subcategories: categories.doc(this.categoryKey).collection('subcategories')
      }
    },
    methods: {
      split(value) {
				let map = {
					"À": "A",
					"Á": "A",
					"Â": "A",
					"Ã": "A",
					"Ä": "A",
					"Å": "A",
					"Æ": "AE",
					"Ç": "C",
					"È": "E",
					"É": "E",
					"Ê": "E",
					"Ë": "E",
					"Ì": "I",
					"Í": "I",
					"Î": "I",
					"Ï": "I",
					"Ð": "D",
					"Ñ": "N",
					"Ò": "O",
					"Ó": "O",
					"Ô": "O",
					"Õ": "O",
					"Ö": "O",
					"Ø": "O",
					"Ù": "U",
					"Ú": "U",
					"Û": "U",
					"Ü": "U",
					"Ý": "Y",
					"ß": "s",
					"à": "a",
					"á": "a",
					"â": "a",
					"ã": "a",
					"ä": "a",
					"å": "a",
					"æ": "ae",
					"ç": "c",
					"è": "e",
					"é": "e",
					"ê": "e",
					"ë": "e",
					"ì": "i",
					"í": "i",
					"î": "i",
					"ï": "i",
					"ñ": "n",
					"ò": "o",
					"ó": "o",
					"ô": "o",
					"õ": "o",
					"ö": "o",
					"ø": "o",
					"ù": "u",
					"ú": "u",
					"û": "u",
					"ü": "u",
					"ý": "y",
					"ÿ": "y",
					"Ā": "A",
					"ā": "a",
					"Ă": "A",
					"ă": "a",
					"Ą": "A",
					"ą": "a",
					"Ć": "C",
					"ć": "c",
					"Ĉ": "C",
					"ĉ": "c",
					"Ċ": "C",
					"ċ": "c",
					"Č": "C",
					"č": "c",
					"Ď": "D",
					"ď": "d",
					"Đ": "D",
					"đ": "d",
					"Ē": "E",
					"ē": "e",
					"Ĕ": "E",
					"ĕ": "e",
					"Ė": "E",
					"ė": "e",
					"Ę": "E",
					"ę": "e",
					"Ě": "E",
					"ě": "e",
					"Ĝ": "G",
					"ĝ": "g",
					"Ğ": "G",
					"ğ": "g",
					"Ġ": "G",
					"ġ": "g",
					"Ģ": "G",
					"ģ": "g",
					"Ĥ": "H",
					"ĥ": "h",
					"Ħ": "H",
					"ħ": "h",
					"Ĩ": "I",
					"ĩ": "i",
					"Ī": "I",
					"ī": "i",
					"Ĭ": "I",
					"ĭ": "i",
					"Į": "I",
					"į": "i",
					"İ": "I",
					"ı": "i",
					"Ĳ": "IJ",
					"ĳ": "ij",
					"Ĵ": "J",
					"ĵ": "j",
					"Ķ": "K",
					"ķ": "k",
					"Ĺ": "L",
					"ĺ": "l",
					"Ļ": "L",
					"ļ": "l",
					"Ľ": "L",
					"ľ": "l",
					"Ŀ": "L",
					"ŀ": "l",
					"Ł": "l",
					"ł": "l",
					"Ń": "N",
					"ń": "n",
					"Ņ": "N",
					"ņ": "n",
					"Ň": "N",
					"ň": "n",
					"ŉ": "n",
					"Ō": "O",
					"ō": "o",
					"Ŏ": "O",
					"ŏ": "o",
					"Ő": "O",
					"ő": "o",
					"Œ": "OE",
					"œ": "oe",
					"Ŕ": "R",
					"ŕ": "r",
					"Ŗ": "R",
					"ŗ": "r",
					"Ř": "R",
					"ř": "r",
					"Ś": "S",
					"ś": "s",
					"Ŝ": "S",
					"ŝ": "s",
					"Ş": "S",
					"ş": "s",
					"Š": "S",
					"š": "s",
					"Ţ": "T",
					"ţ": "t",
					"Ť": "T",
					"ť": "t",
					"Ŧ": "T",
					"ŧ": "t",
					"Ũ": "U",
					"ũ": "u",
					"Ū": "U",
					"ū": "u",
					"Ŭ": "U",
					"ŭ": "u",
					"Ů": "U",
					"ů": "u",
					"Ű": "U",
					"ű": "u",
					"Ų": "U",
					"ų": "u",
					"Ŵ": "W",
					"ŵ": "w",
					"Ŷ": "Y",
					"ŷ": "y",
					"Ÿ": "Y",
					"Ź": "Z",
					"ź": "z",
					"Ż": "Z",
					"ż": "z",
					"Ž": "Z",
					"ž": "z",
					"ſ": "s",
					"ƒ": "f",
					"Ơ": "O",
					"ơ": "o",
					"Ư": "U",
					"ư": "u",
					"Ǎ": "A",
					"ǎ": "a",
					"Ǐ": "I",
					"ǐ": "i",
					"Ǒ": "O",
					"ǒ": "o",
					"Ǔ": "U",
					"ǔ": "u",
					"Ǖ": "U",
					"ǖ": "u",
					"Ǘ": "U",
					"ǘ": "u",
					"Ǚ": "U",
					"ǚ": "u",
					"Ǜ": "U",
					"ǜ": "u",
					"Ǻ": "A",
					"ǻ": "a",
					"Ǽ": "AE",
					"ǽ": "ae",
					"Ǿ": "O",
					"ǿ": "o"},
				nonWord = /\W/g,
				mapping = c => {
					return map[c] || c;
				}
				return value.replace(nonWord, mapping).toLowerCase().split(' ').join('-')
      },
			confirmRemoveCategory() {
        if( this.subcategories.length === 0 ) {
          categories.doc(this.categorySlug).get().then( snapshot => {
            const slug = this.categorySlug
            const desertRef = storageFiles.child('public/thumbnails/' + this.categoryBackground)
            desertRef.delete().then( () => {
              categories.doc(slug).delete().then( () => {
								busNotifications.makeNotification('success', 'success!')
							})
            })
          })
        } else {
					busNotifications.makeNotification('warning', 'There are files linked to this category, first delete the linked files')
        }
				$('#modal-' + this.categorySlug).modal('hide')
      },
      confirmRemoveSubcategory() {
        categories.doc(this.categoryKey).collection('subcategories').doc(this.keySubcategory).collection('files').get().then( doc => {
          if( doc.size === 0 ) {
            categories.doc(this.categorySlug).collection('subcategories').doc(this.keySubcategory).delete().then( () => {
								busNotifications.makeNotification('success', 'success!')
						})
          } else {
            busNotifications.makeNotification('warning', 'There are files linked to this subcategory, first delete the linked files')
          }
        });
				$('#modal-remove-subcategory-' + this.categorySlug).modal('hide')
			},
      confirmAddSubcategory() {
        const subCategory = this.split(this.nameSubCategory);
        categories.doc(this.categoryKey).collection('subcategories').doc(subCategory).set({
          name: this.nameSubCategory,
          slug: subCategory
        });
        this.nameSubCategory = '';
				$('#modal-add-subcategory-' + this.categorySlug).modal('hide');
				busNotifications.makeNotification('success', 'the subcategory has been added')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/CategoryTable.vue